import React from 'react';

export default class TicketStubRow extends React.Component {
  static propTypes = {
    children: React.PropTypes.node
  };

  render () {
    return (
      <div className="ticket_stub_row">
        {this.props.children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/common/ticket_stub/row.js